// extracted by mini-css-extract-plugin
export default {"mobCOList":"styles_mobCOList__hiuZA","mobCOList__landscape":"styles_mobCOList__landscape__Q852+"};